import { twMerge } from "tailwind-merge";

import type { Styled } from "~/utils";

interface PulseProps extends Styled {
  containerClassName?: string;
}

export const Pulse = ({ className, containerClassName }: PulseProps) => {
  return (
    <div className={containerClassName}>
      <div
        className={twMerge(
          "h-3 w-full animate-pulse rounded-md bg-neutral-80",
          className,
        )}
      />
    </div>
  );
};
